export default "__VITE_ASSET__906fceb0__"